/**
 * Component: sa-footer-icon-text
 * Description: Footer icon text section component
 */
if (!customElements.get('sa-footer-icon-text')) {
  class SaFooterIconText extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this.isConnected) {
        return;
      }
    }

    disconnectedCallback() {
    }
  }

  customElements.define('sa-footer-icon-text', SaFooterIconText);
}
